import { IDemoDayRankingEntry } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useRef } from 'react';

import { sdk } from '@/services';

const DemoDayService = sdk.getService('DemoDayService');

export const useDemoDayRanking = () => {
  const { isLoading, data } = useQuery({
    queryKey: ['demo-day-ranking'],
    queryFn: () => DemoDayService.getRanking(),
    refetchInterval: 5000,
    refetchOnWindowFocus: true
  });

  const ranking: IDemoDayRankingEntry[] = data ?? [];
  const prevPositionsRef = useRef<Map<string, number>>(new Map());
  const positionChangesRef = useRef<Map<string, number>>(new Map());

  useEffect(() => {
    if (ranking.length === 0) return;

    const prev = prevPositionsRef.current;
    const changes = new Map<string, number>();

    ranking.forEach((entry, index) => {
      const prevIndex = prev.get(entry._id);
      if (prevIndex !== undefined && prevIndex !== index) {
        changes.set(entry._id, prevIndex - index);
      }
    });

    positionChangesRef.current = changes;

    const next = new Map<string, number>();
    ranking.forEach((entry, index) => next.set(entry._id, index));
    prevPositionsRef.current = next;
  }, [ranking]);

  const positionChanges = useMemo(() => positionChangesRef.current, [ranking]);

  return {
    isLoading,
    ranking,
    positionChanges
  };
};
